import { memo } from 'react';
import { LABEL } from '@veriables';

const CartHeader = ({ serverAppTheme, activeTab }) => (
  <div
    className="pt-1 fs_12 d-flex pl-0 h-5"
    style={{ color: serverAppTheme?.secondary_text }}
  >
    <div className="col-1 p-0" />
    <div className="col-1 px-0 pl-0">Qty</div>
    <div className="col-5 px-2">Items</div>
    <div className="col-2 px-0 text-center">Seat</div>
    <div className="col-3 px-0 pl-1">
      {activeTab === 'sent' ? '$Amt' : `${LABEL().CURRENCY_SYMBOL}Amt`}
    </div>
  </div>
);

export default memo(CartHeader);
